import {
  WIDTH_DOUBLE_AIGUILLAGE,
  WIDTH_SIMPLE_AIGUILLAGE,
  WIDTH_TEXT_VOIE,
} from '../constants/constants'
import {ESwitchType, TSwitch} from '../types/project.type'
import {stretchExtra, type TAxisStretch} from './axisStretch'

export const getGridCell = (
  kmStart: number,
  kmEnd: number,
  echantillonValue: number,
  switches: TSwitch[],
  stretches: TAxisStretch[] = [],
) => {
  const gridCell = [0]
  let total = 0

  for (let i = kmStart; i <= kmEnd; i += echantillonValue) {
    const aiguillageAtThisKm = switches.filter((ele: any) => ele.kmPoint === i)
    if (aiguillageAtThisKm.length > 0) {
      const currentAiguillage = aiguillageAtThisKm[0]
      if (currentAiguillage.type === ESwitchType.DOUBLE) {
        total += WIDTH_DOUBLE_AIGUILLAGE
      } else {
        total += WIDTH_SIMPLE_AIGUILLAGE
      }
    } else {
      total += WIDTH_TEXT_VOIE
    }
    total += stretchExtra(stretches, i, i + echantillonValue, echantillonValue)
    gridCell.push(Number(total.toFixed(2)))
  }
  return gridCell
}
